var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"py-2 px-0",attrs:{"id":"sel","items":_vm.finishes,"item-value":"key","item-text":"name","label":"Настройки подсветки","dense":"","hide-details":"","outlined":"","menu-props":{
    bottom: true,
    offsetY: true,
    transition: 'scale-transition',
  },"single-line":""},on:{"change":_vm.changed},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }